import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';

export interface PatientDentalTreatmentplanParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}

export interface PatientDentalTreatmentplan {

    id?: number;
    treatmentPlanNotes: string;   
    treatmentPlanId: any;
    nextVisitDate:Date;
    followUp?: string;
    startDate?:any;
    endDate?:any;
    treatmentStatus?:string;
    indentFhir?:string;
    visitId?:any;
    regId: string; 
    doctorId?:string;    
    tenantId: any;
    branchId: any;
    createdDate?:Date;
    updatedDate?:Date;
    createdBy?:number;
    updatedBy?:number;
    createdIP?:string;
    updatedIP?:string;
    parameters?: PatientDentalTreatmentplanParameter[];
    links?: any;

}


export abstract class PatientDentalTreatmentplanData { 

    abstract list(url: string): Observable<PatientDentalTreatmentplan[]>;
    abstract create(url: string, data: PatientDentalTreatmentplan): Observable<any>;
    abstract update(url: string, data: PatientDentalTreatmentplan): Observable<any>;
    abstract delete(url: string): Observable<any>; 
   
}

